/**
 * Normalize GET /api/play/playdates list JSON (production flat envelope).
 *
 * Canonical success shape:
 *   { success: true, items: CirclePlaydateDto[], nextCursor: string | null }
 *
 * Do not invent nested `data.items` as the primary contract — tests and clients
 * must accept the flat production response that Cloud Run actually returns.
 */

import type { CirclePlaydateDto } from '@/lib/play/circlePlaydateDto'

export type CirclePlaydatesListResponse = {
  success: boolean
  items: CirclePlaydateDto[]
  nextCursor: string | null
}

export function parseCirclePlaydatesListResponse(
  raw: unknown
): CirclePlaydatesListResponse | null {
  if (!raw || typeof raw !== 'object') return null
  const record = raw as Record<string, unknown>
  if (record.success !== true) return null
  if (!Array.isArray(record.items)) return null

  const nextCursor =
    typeof record.nextCursor === 'string'
      ? record.nextCursor
      : record.nextCursor === null
        ? null
        : null

  return {
    success: true,
    items: record.items as CirclePlaydateDto[],
    nextCursor,
  }
}
